<template>
	<div class="add_user_wrap">
    <el-button type="primary" size="small" @click="pop_show = true" class="pull-right">增加权限</el-button>
    <el-dialog title="增加权限" :visible.sync="pop_show" append-to-body>
        <el-form :model="authorForm" status-icon :rules="rulesAuthorForm" ref="authorForm" label-width="100px">
          <el-form-item label="选择类型：" prop="type">
            <template>
              <el-radio-group @change='fn' v-model="authorForm.type">
                <el-radio :label="0">菜单</el-radio>
                <el-radio :label="1">权限点</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="父级：" prop="content_type">
            <el-select v-model="authorForm.content_type" size="small">
              <el-option
                v-if='authorForm.type===0'
                label="无父级"
                value="0">
              </el-option>
              <el-option
                v-for="item in content_type_list"
                :key="item.permission_id"
                :label="item.name"
                :value="item.permission_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限名称：" prop="name">
            <el-input type="text" v-model="authorForm.name" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="权限链接：" prop="code">
            <el-input type="text" v-model="authorForm.code" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="排序号：" prop="sequence">
            <el-input type="text" v-model="authorForm.sequence" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm()">提交</el-button>
            <el-button @click="resetForm('authorForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
	</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'AddUser',
  data () {
    var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('名称不能为空'));
        } else {
          callback()
        }
    };
    var validateCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('链接不能为空'));
        } else {
          callback()
        }
    };
    var validateSequence = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('序号不能为空!'));
        } else {
          callback()
        }
    };
    return {
      pop_show:false,
      content_type_list:[],
      authorForm:{
        name:'',
        code:'',
        type:'',
        sequence: '',
        content_type: ''
      },
      rulesAuthorForm:{
        name: [
            { validator:validateName, trigger: 'blur' }
        ],
        sequence: [
            { validator:validateSequence, trigger: 'blur' }
        ],
        code: [
            { validator:validateCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    submitForm(){
      if(this.authorForm.type === ''){
        this.$message({
          type:'error',
          message:'请选择权限类型'
        });
        return
      }

      if(this.authorForm.content_type === ''){
        this.$message({
          type:'error',
          message:'请选择父级'
        });
        return
      }
      let token = localStorage.token;

        this.axios.post(cons.apis + '/v1_0/permissions', {
              "name":this.authorForm.name,
              "code":this.authorForm.code,
              "type":this.authorForm.type,
              "parent_id":this.authorForm.content_type,
              "sequence":this.authorForm.sequence
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            if(dat.status==201){
              this.$message({
                type: 'success',
                message: '添加权限成功!'
              });
              this.pop_show = false;
              this.resetForm('authorForm');
              this.$emit('fnResetTable');
            }
            if(dat.data.message !== 'OK'){
              this.$message({
                type:'info',
                message:'权限名称已存在'
              });
            }
        }).catch(err=>{
          console.log(err)
           //  if(err.data.response.status==400){
           //    var errmsg = err.response.data;

           //    if(errmsg.name){
           //      this.$message({
           //        type:'info',
           //        message:errmsg.name[0]
           //      });
           //    }

           //    if(errmsg.non_field_errors){
           //      this.$message({
           //        type:'info',
           //        message:errmsg.non_field_errors[0]
           //      });
           //    }
           // }
        });
    },
    fnGetTypeList(){

    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    fn(){
      let token = localStorage.token;

      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
        params: {
          type: 0,
          per_page: 50
        }
      })
      .then(dat=>{
          this.content_type_list = dat.data.data.permissions;

      }).catch(err=>{
         console.log(err.response);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widget/AddAuthor.vue